"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _basicLayout = _interopRequireDefault(require("@/layouts/basic-layout"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const meta = {
  title: '文案创作',
  auth: true
};
const pre = "image-";
var _default = {
  path: "/text",
  name: "textWriting",
  meta,
  component: () => import('@/pages/text-writing')
};
exports.default = _default;